<template>
  <div :class="['main', { 'workspace-layout': ready }]" style="height:100%; width:100%;">

      <LandingPage v-if="!ready" v-on:on-sample-selected="onSampleClick($event)"/>

      <div v-show="ready" class="readyLeftCol">
        <Colorspace 
          :curColors="svgColors" 
          :refreshPalette="refresh" 
          :selectedElementColor="selectedElementColor"
          v-on:on-user-select-color-change="applyColors($event)"
          v-on:on-user-hover-on-color="userHoverOnCurrentColor($event)"
          v-on:on-reset-colors="resetSvgContent()"
          v-on:on-element-unselected="unselectElement()"
          v-on:on-element-color-change="updateElementColor($event)"
          v-on:on-element-translate="updateElementTranslate($event)"
          v-on:on-element-scale="updateElementScale($event)"
          v-on:on-element-rotate="updateElementRotate($event)" />
      </div>

      <div :class="{ readyRightCol: ready }" :style="!ready ? { display: 'none' } : {}">  
        <Workspace 
          v-on:on-colors-from-svg="showColorsInCurrentPallete($event)" 
          v-on:refresh-palette="refreshPalettes()"
          v-on:ready-for-new-upload="readyForNewUpload($event)" 
          v-on:on-svg-added-in-workspace="notifyFooter()"
          v-on:element-selected="elementSelected($event)"
          v-on:element-unselected="unselectElement()"
          :newColors="newColors" 
          :newSVG="newSample"
          :highlightColor="highlightCol"
          :resetSvg="resetFullSvg"
          :newElementColor="newElementColor"
          :newElementTranslate="newElementTranslate"
          :newElementScale="newElementScale"
          :newElementRotate="newElementRotate"
          :clearSelection="clearSelectionToggle" />
      </div>

      <div v-if="!ready">
        <ExplCards v-on:on-sample-selected="onSampleClick($event)"/>
      </div>

  </div>
</template>

<script>
import Workspace from './Workspace.vue'
import Colorspace from './Colorspace.vue'
//import LandText from './LandText.vue'
//import LandPic from './LandPic.vue'
import ExplCards from './ExplCards.vue'
import LandingPage from './LandingPage.vue'

export default {
  name: 'Main',
  components: {
    Workspace,
    Colorspace,
    //LandText,
    //LandPic,
    ExplCards,
    LandingPage
  },
  props: {},
  data(){
    return {
      svgColors: [],
      newColors: [],
      ready: false,
      workspaceSpan: 12,
      newSample: null,
      refresh: false,
      highlightCol: null,
      resetFullSvg: false,
      selectedElementColor: null,
      newElementColor: null,
      newElementTranslate: null,
      newElementScale: null,
      newElementRotate: null,
      clearSelectionToggle: false
    }
  },
  methods:{
    onSampleClick(data){
      this.newSample = data;
      this.notifyFooter();
    },
    notifyFooter(){
      console.log("emitting on-workspace-settingup");
      this.$emit('on-workspace-settingup');
    },
    showColorsInCurrentPallete(svgColors){
      if(svgColors!=null){
        this.ready = true;
        this.workspaceSpan = 16;
        this.svgColors = svgColors;
      }
    },
    applyColors(newcolors){
      if(newcolors!=null){
        this.newColors = Array.from(newcolors);
      }else{
        console.log("new colors is null!");
      }
    },
    readyForNewUpload(){
      this.ready = false;
      this.workspaceSpan = 12;
    },
    refreshPalettes(){
      console.log("notice to refresh!");
      this.refresh = !this.refresh;
    },
    userHoverOnCurrentColor(event){
      this.highlightCol = event
    },
    resetSvgContent(){
      this.resetFullSvg = !this.resetFullSvg;
    },
    elementSelected(color) {
      this.selectedElementColor = color;
      this.newElementColor = null; // Reset
      this.newElementTranslate = null; // Reset
      this.newElementScale = null; // Reset
      this.newElementRotate = null; // Reset
    },
    unselectElement() {
      this.selectedElementColor = null;
      this.newElementColor = null;
      this.newElementTranslate = null;
      this.newElementScale = null;
      this.newElementRotate = null;
      this.clearSelectionToggle = !this.clearSelectionToggle;
    },
    updateElementColor(color) {
      this.newElementColor = color;
    },
    updateElementTranslate(translateObj) {
      this.newElementTranslate = translateObj;
    },
    updateElementScale(scaleVal) {
      this.newElementScale = scaleVal;
    },
    updateElementRotate(rotateVal) {
      this.newElementRotate = rotateVal;
    }
  }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.main {
  width: 100%;
}

.workspace-layout {
  display: flex;
  flex-direction: row;
  height: 100%;
}

.readyLeftCol{
  flex: 0 0 25%;
  min-width: 380px;
  height: 100%;
  padding: 20px;
  box-sizing: border-box;
}

.readyRightCol{
  flex: 1;
  height: 100%;
  overflow-y: auto;
  padding: 20px;
  box-sizing: border-box;
}

@media screen and (max-width: 800px) {
  .workspace-layout {
    flex-direction: column;
  }
  .readyLeftCol, .readyRightCol {
    flex: 0 0 100%;
    width: 100%;
  }
}

</style>
